<template>
   <div class="section">
    <div class="_1200 w-clearfix">
      <h2 class="sec-heading">האיזור האישי</h2>
      </div>
    <div class="_1200 flex">
      <div class="tags-box">
        <a :class="activeView == 'personal'?'w--current':''" v-on:click="activeView = 'personal'" href="#" class="tag"><strong>פרטים אישיים</strong></a>
        <a :class="activeView == 'halufot'?'w--current':''" v-on:click="activeView = 'halufot'" href="#" class="tag"><strong>תכניות הלימודים שלי</strong></a>
        </div>
      <div class="collection-list-wrapper">

        <div v-if="activeView == 'personal'" class="white-box bg">
          <label>תמונת פרופיל</label>
          <div class="add-new w-button" style="position: relative; margin-bottom: 16px;">
          {{$parent.user.profileImg?'':file?'מעלה תמונה...':'+ הוספת תמונת פרופיל '}}
          <img v-if="img" style="max-height:100px;" :src="$parent.user.profileImg">
          <input type="file" @change="uploadfile($event.target.files[0])" width="100%" height="100%" style="width: 100%;position: absolute; opacity: 0; top: 0px; right: 0px; left: 0px; bottom: 0px;">
          </div>
          <label>שם מלא</label>
          <input class="w-input" type="text" placeholder="שם מלא" v-model="$parent.user.name">
                    <label>בית הספר</label>
          <input class="w-input" type="text" placeholder="בית הספר" v-model="$parent.user.school">
          <label>כתובת מייל</label>
          <input class="w-input" type="text" placeholder="כתובת מייל" v-model="$parent.user.email">
          <a class="btn zone w-button router-link-exact-active router-link-active" type="button" placeholder="שם מלא">עדכון פרטים</a>
      </div>
              <div class="collection-list-flex" v-if="activeView == 'halufot'">
          <div v-for="halufa in halufot" :key="halufa.id" class="collection-item w-embed">
            <router-link :to="'/alternative/'+halufa.id" class="white-box w-inline-block">
              <div class="white-box-head-box">
                <h3 class="white-box-head space">{{halufa.name}}</h3>
                <h3 class="white-box-above-head">{{halufa.author}}</h3>
              </div>
              <div class="innertxt-box">
                <p class="white-box-txt">{{halufa.description}}</p>
              </div>
              <img src="images/bookmark.svg" alt="" class="bookmark hide">
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'alternatives',
  data(){
      return{
      file:'',
      user:'',
      img:'',
      units:[],
      activeView:'personal',
      halufot:[]
      }
    },
    methods:{
      uploadfile(file){
        this.file = 'uploading'
        var storageRef = firebase.storage().ref(`${this.$parent.user.name}/${file.name}`);
        var uploader = storageRef.put(file);
        uploader.on('state_changed', () => {
      }, (err) => {
          alert("error",err);
      }, () => {
          uploader.snapshot.ref.getDownloadURL().then((url) => {
            db.doc('/collections/nZSsggipwqsg74x8nJBu/items/'+this.$parent.user.uid).update({profileImg:url}).then(()=>{
              this.$parent.user.profileImg = url
              this.img = true
            })
      });
      })
    }
    },
    mounted(){
      if (this.$parent.user.profileImg){
        this.img = true
      }
      if (this.$parent.user.halufot){
      this.$parent.user.halufot.forEach(e=>{
        db.doc('/collections/oVwbkKRU39ykpil2lw62/items/'+e).get().then((doc)=>{
            var data = doc.data()
            data.id = doc.id
            this.halufot.push(data)
        })
      })
      }
      },
      computed:{
        busFilter(){
          if (!this.search){
            return(this.businesses);
          } else {
            //var term = new RegExp(this.selectedUI.search, 'gi')
            //return this.categories.filter((e)=>{e.name.match(term)})
            return this.searchFunc(this.businesses,"businessName",this.search);
          }
        }
      },
      watch:{
        activeUnit(){
            this.halufot = []
            this.getHalufa()
        }
      }
}
</script>

<style scoped>
.white-box.bg:hover {
   box-shadow: 0 10px 30px 0 rgba(42, 83, 187, 0.05);
  -webkit-transform: translate(0px, 0px);
  -ms-transform: translate(0px, 0px);
  transform: translate(0px, 0px);
}

.white-box.bg{
  padding:40px;
}
</style>
